module.exports = __webpack_public_path__ + "static/media/logo_icon@3x.29d8eaf5.jpg";